<div class="fault-analysis-filters">
  @let machines = machineOptions();
  @let faults = faultCodeGroups();

  @if (machines) {
    <div class="flex">
      <div class="filter machines">
        <geaui-multi-select-v3
          id="machines"
          [label]="'FAULT_ANALYSIS.MACHINE' | translate"
          [value]="formGroup.machines().value()"
          [options]="machines"
          (clearButtonClick)="clearSelectedMachines()"
          (valueChange)="onSetSelectedMachines($event)" />
      </div>
      @if (selectedMachines()?.length) {
        <div class="filter dateRange">
          <geaui-select-v3
            id="dateRange"
            [label]="'FAULT_ANALYSIS.DATE_RANGE' | translate"
            [options]="[
              { name: 'FAULT_ANALYSIS.FILTERS.DATE_RANGE.LAST_24_HOURS' | translate, value: 1 },
              { name: 'FAULT_ANALYSIS.FILTERS.DATE_RANGE.LAST_WEEK' | translate, value: 7 },
              { name: 'FAULT_ANALYSIS.FILTERS.DATE_RANGE.LAST_2_WEEKS' | translate, value: 14 },
              { name: 'FAULT_ANALYSIS.FILTERS.DATE_RANGE.LAST_4_WEEKS' | translate, value: 28 },
            ]"
            [sortFunction]="sortDateRange"
            [sortOptions]="true"
            [selected]="formGroup.dateRange().value()[0]"
            (selectChanged)="onSetDateRange($event)" />
        </div>
        <div class="filter status">
          <geaui-multi-select-v3
            id="status"
            [label]="'FAULT_ANALYSIS.FAULT_STATUS' | translate"
            [options]="[
              { name: 'FAULT_ANALYSIS.FAULT_STATUS.PENDING' | translate, value: FaultStatus.PENDING },
              { name: 'FAULT_ANALYSIS.FAULT_STATUS.SOLVED' | translate, value: FaultStatus.SOLVED },
            ]"
            [value]="formGroup.status().value()"
            (valueChange)="onSetStatus($event)" />
        </div>
        <div class="filter faults">
          @if (faults) {
            <geaui-multi-select-v3
              id="faultCodes"
              [label]="'FAULT_ANALYSIS.FAULT_NAME' | translate"
              [options]="faults"
              [disabled]="!faults.length"
              (clearButtonClick)="onSetSelectedFaultCodes()"
              [value]="formGroup.faultCodes().value()"
              (valueChange)="onSetSelectedFaultCodes($event)" />
          } @else {
            <gea-hrt-spinner />
          }
        </div>
      }
    </div>
  } @else {
    <gea-hrt-spinner />
  }
</div>
